import controllerLoadedObservableFactory from '@newswebsiteapp/shared/observables/controllerLoadedObservableFactory'
import setupTooltip from '@newswebsiteapp/shared/lib/setupTooltip'

controllerLoadedObservableFactory('profile_payment_methods').subscribe(
  async () => {
    setupTooltip()
  },
)
